import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RutaConAsignatura, RutaSegType } from 'components/seguimientoDesafio/seguimientoDesafio.graphql';
import { Rutas } from 'generated/graphql';

interface DisplayGuiaSeg {
	display: boolean;
	type: RutaSegType;
	rutaKey: string | null;
	rutaData: RutaConAsignatura | null;
	listRuta: Rutas[] | undefined | null;
}

const initialState: DisplayGuiaSeg = {
	display: false,
	type: null,
	rutaKey: null,
	rutaData: null,
	listRuta: null
};

const displayDesafioSegSlice = createSlice({
	name: 'displayDesafioSeg',
	initialState,
	reducers: {
		setDisplayDesafioSeg: (state, action: PayloadAction<DisplayGuiaSeg>) => {
			return action.payload;
		},
		updateTypeDisplayDesafioSeg: (state, action) => {
			return {
				...state,
				type: action.payload.type
			};
		},

		updateRutaDisplayDesafioSeg: (state, action) => {
			return {
				...state,
				rutaKey: action.payload.rutaKey,
				rutaData: action.payload.rutaData
			};
		},
		resetDisplayDesafioSeg: () => {
			return initialState;
		}
	}
});

export const {
	resetDisplayDesafioSeg,
	setDisplayDesafioSeg,
	updateTypeDisplayDesafioSeg,
	updateRutaDisplayDesafioSeg
} = displayDesafioSegSlice.actions;

export default displayDesafioSegSlice.reducer;
